import i18next from 'i18next';
import uz from './navigation-i18n/uz'
import en from './navigation-i18n/en';
import ru from './navigation-i18n/ru';
import oz from './navigation-i18n/oz';

i18next.addResourceBundle('en', 'translate-language', en);
i18next.addResourceBundle('ru', 'translate-language', ru);
i18next.addResourceBundle('uz', 'translate-language', uz);
i18next.addResourceBundle('oz', 'translate-language', oz);

const navigationConfig = [
  {
    id: 16,
    title: 'Home',
    translate: 'Home',
    type: 'item',
    icon: 'material-solid:menu_book',
    url: 'home',
  },
  {id: 1,
  title: 'Журнал записи',
  translate: 'TheRegistry',
  type: 'item',
  icon: 'material-solid:menu_book',
  url: 'calendar/workingstaff',
    children: [
      {
        id: 'thePatients',
        title: 'ThePatients',
        type: 'item',
        url: 'calendar/workingstaff',
        translate: 'ThePatients',
        end: true,
      },
     {
        id: 'thePatients',
        title: 'ThePatients',
        type: 'item',
        url: 'calendar/mobile',
        translate: 'ThePatients',
        end: true,
      },]

},
  
  {
    id: 5,
    title: 'ThePatients',
    type: 'collapse',
    icon: 'heroicons-solid:user-group',
    translate: 'ThePatients',
    border: "true",
    children: [
      {
        id: 'thePatients',
        title: 'ThePatients',
        type: 'item',
        url: 'clients/clients',
        translate: 'ThePatients',
        end: true,
      },
      // {
      //   id: 'waitingList',
      //   title: 'WaitingList',
      //   type: 'item',
      //   url: 'clients/wait-list',
      //   translate: 'WaitingList',
      //   end: true,
      // },
      // {
      //   id: 'services-your',
      //   title: 'Telephony',
      //   type: 'item',
      //   url: 'clients/telephony',
      //   translate: 'Telephony',
      //   end: true,
      // },
    ],
  },
  {
    id: 4,
    title: 'Doctors',
    type: 'collapse',
    icon: 'heroicons-solid:user',
    translate: 'Doctors',
    border: "true",
    children: [
      {
        id: 'workingHours',
        title: 'WorkingHours',
        type: 'item',
        url: 'staff/workinghours',
        translate: 'WorkingHours',
        end: true,
      },
      {
        id: 'staff',
        title: 'Doctors',
        type: 'item',
        url: 'staff/staff',
        translate: 'Doctors',
        end: true,
      },

      // {
      //   id: 'testimonials',
      //   title: 'Testimonials',
      //   type: 'item',
      //   url: 'staff/feedback',
      //   translate: 'Testimonials',
      //   end: true,
      // },

    ],
  },
  {
    id: 3,
    title: 'Services',
    type: 'collapse',
    icon: 'material-outline:fact_check',
    translate: 'Services',
    border: "true",
    children: [
      {
        id: 'servicess',
        title: 'Services',
        type: 'item',
        url: 'services',
        translate: 'Services',
        end: true,
      },
      // {
      //   id: 'resources',
      //   title: 'Resources',
      //   type: 'item',
      //   url: 'resources',
      //   translate: 'Resources',
      //   end: true,
      // },
    ],
  },
  // {
  //   id: 6,
  //   title: 'EmailSMS',
  //   type: 'collapse',
  //   icon: 'material-outline:email',
  //   translate: 'EmailSMS',
  //   border: "true",
  //   children: [
  //     {
  //       id: 'autoNotifications',
  //       title: 'AutoNotifications',
  //       type: 'item',
  //       url: 'email_sms/auto_notification',
  //       translate: 'AutoNotifications',
  //       end: true,
  //     },
  //     {
  //       id: 'mailOut',
  //       title: 'MailOut',
  //       type: 'item',
  //       url: 'email_sms/smsletter',
  //       translate: 'MailOut',
  //       end: true,
  //     },
  //     // {
  //     //   id: 'balance',
  //     //   title: 'Balance',
  //     //   type: 'item',
  //     //   url: 'email_sms/balance',
  //     //   translate: 'Balance',
  //     //   end: true,
  //     // },
  //     {
  //       id: 'messageHistory',
  //       title: 'MessageHistory',
  //       type: 'item',
  //       url: 'email_sms/history',
  //       translate: 'MessageHistory',
  //       end: true,
  //     },
  //   ],
  // },
  {
    id: 6,
    title: 'Analytics',
    type: 'collapse',
    icon: 'material-outline:analytics',
    translate: 'Analytics',
    border: "true",
    children: [
      {
        id: 'generalAnalyticsl',
        title: 'GeneralAnalytics',
        type: 'item',
        url: 'analytics/general',
        translate: 'GeneralAnalytics',
        end: true,
      },
      {
        id: 'employees',
        title: 'Employeess',
        type: 'item',
        url: 'analytics/staff',
        translate: 'Employees',
        end: true,
      },
      // {
      //   id: 'services',
      //   title: 'Services',
      //   type: 'item',
      //   url: 'analytics/services',
      //   translate: 'Services',
      //   end: true,
      // },
      // {
      //   id: 'blackBox',
      //   title: 'BlackBox',
      //   type: 'item',
      //   url: 'analytics/log',
      //   translate: 'BlackBox',
      //   end: true,
      // },
    ],
  },
 
  {
    id: 8,
    type: 'collapse',
    icon: 'material-outline:playlist_add_check',
    border: "true",
    title: 'Products',
    url: 'products',
    translate: 'Products',
    end: true,
    children: [
      {
        id: 'inventory',
        title: 'Products',
        type: 'item',
        url: 'products',
        translate: 'Products',
        end: true,
      },
      {
        id: 'order-products-status',
        title: 'Buyurtmali mahsulotlar',
        type: 'item',
        url: 'material/order-products',
        translate: 'OrderProducts',
        end: true,
      },
      {
        id: 'inventory',
        title: 'Seria',
        type: 'item',
        url: 'search-seria',
        translate: 'SearchSeria',
        end: true,
      }
    ]
  },
  {
    id: 15,
    title: 'Report',
    type: 'collapse',
    icon: 'feather:file-text',
    translate: 'Report',
    border: "true",
    children: [
      {
        id: 'inventory',
        title: 'Finance',
        type: 'item',
        url: 'material/report/finance',
        translate: 'Finance',
        end: true,
      },
      {
        id: 'inventory',
        title: 'Payments',
        type: 'item',
        url: 'material/report/payments',
        translate: 'Kirim',
        end: true,
      },
      {
        id: 'salarySettingsUserAuto',
        title: 'Chiqim',
        type: 'item',
        url: 'salary/consumption',
        translate: 'Chiqim',
        end: true,
      },
      {
        id: 'inventory',
        title: 'DebitOrderTransact',
        type: 'item',
        url: 'material/report/debit-order-transacts',
        translate: 'DebitOrderTransact',
        end: true,
      },

      {
        id: 'inventory',
        title: 'DebitTransactSummary',
        type: 'item',
        url: 'material/report/debit-transact-summary',
        translate: 'DebitTransactSummary',
        end: true,
      },
      {
        id: 'inventory',
        title: 'DebitTransactSummary',
        type: 'item',
        url: 'material/report/debit-transacts',
        translate: 'SalesHistory',
        end: true,
      },
      {
        id: 'inventory',
        title: 'DebitTransactSummary',
        type: 'item',
        url: 'material/report/full-order-list',
        translate: 'Services',
        end: true,
      },
      {
        id: 'inventory',
        title: 'DebitTransactSummary',
        type: 'item',
        url: 'material/report/total-transact-summary',
        translate: 'TotalTransactSummary',
        end: true,
      },
      {
        id: 'inventory',
        title: 'DebitTotalTransact',
        type: 'item',
        url: 'material/report/debit-total-transacts',
        translate: 'DebitTotalTransact',
        end: true,
      },
    ]
  },
  {
    id: 2,
    title: 'Payroll',
    type: 'collapse',
    icon: 'material-outline:account_balance_wallet',
    translate: 'Payroll',
    border: "true",
    children: [
      {
        id: 'payrool',
        title: 'Payroll',
        type: 'item',
        url: 'salary',
        translate: 'Payroll',
        end: true,
      },
      {
        id: 'salarySettings',
        title: 'SalarySettings',
        type: 'item',
        url: 'salary/settings',
        translate: 'SalarySettings',
        end: true,
      },
      {
        id: 'salarySettingsUser',
        title: 'SalarySettings',
        type: 'item',
        url: 'salary/user-salary',
        translate: 'Salaries',
        end: true,
      },
      {
        id: 'salarySettingsUserAuto',
        title: 'SalarySettings',
        type: 'item',
        url: 'salary/user-salary-auto',
        translate: 'AutoSalary',
        end: true,
      },

    ],
  },
  // {
  //   id: 'onlineBooking',
  //   title: 'OnlineBooking',
  //   translate: 'OnlineBooking',
  //   type: 'item',
  //   icon: 'material-outline:pending_actions',
  //   url: 'online_booking',
  // },
  {
    id: 9,
    title: 'CompanysSettings',
    translate: 'CompanysSettings',
    type: 'item',
    icon: 'material-outline:settings',
    url: 'settings',
  },
  {
    id: 10,
    title: 'Продажи',
    translate: 'Sales',
    type: 'item',
    icon: 'material-outline:payment',
    url: 'sales',
  },
  {
    id: 11,
    title: 'Продажи',
    translate: 'Purchase',
    type: 'item',
    icon: 'heroicons-outline:download',
    url: 'purchase',
  },
  {
    id: 12,
    title: 'Продажи',
    translate: 'InterBranch',
    type: 'item',
    icon: 'material-outline:sync',
    url: 'inter-branch',
  },
  {
    id: 13,
    title: 'Directory',
    type: 'collapse',
    icon: 'heroicons-outline:clipboard-list',
    translate: 'Directorys',
    border: "true",
    children: [
      {
        id: 'brands',
        title: 'Brands',
        type: 'item',
        url: 'brands',
        translate: 'Brands',
        end: true,
      },
      {
        id: 'categories',
        title: 'Seria',
        type: 'item',
        url: 'seria',
        translate: 'Serias',
        end: true,
      },
      {
        id: 'subcategories',
        title: 'Categories',
        type: 'item',
        url: 'categories',
        translate: 'Categories',
        end: true,
      },
      {
        id: 'payrool',
        title: 'Directory',
        type: 'item',
        url: 'matrial-type',
        translate: 'MatrialType',
        end: true,
      },
      {
        id: 'payrool',
        title: 'Directory',
        type: 'item',
        url: 'executor-type',
        translate: 'ExecutorType',
        end: true,
      },
      {
        id: 'payrool',
        title: 'Directory',
        type: 'item',
        url: 'colour',
        translate: 'ColourType',
        end: true,
      },
      {
        id: 'payrool',
        title: 'Directory',
        type: 'item',
        url: 'specialization',
        translate: 'Specialization',
        end: true,
      },
      {
        id: 'payrool',
        title: 'Directory',
        type: 'item',
        url: 'ventilation-size',
        translate: 'VentilationType',
        end: true,
      },
      {
        id: 'expense-type',
        title: 'ExpenseType',
        type: 'item',
        url: 'expense-type',
        translate: 'ExpenseType',
        end: true,
      },
      {
        id: 'type',
        title: 'TypeType',
        type: 'item',
        url: 'type',
        translate: 'TypeType',
        end: true,
      },
      {
        id: 'option',
        title: 'Option',
        type: 'item',
        url: 'option',
        translate: 'OptionType',
        end: true,
      },
      // {
      //   id: 'seria',
      //   title: 'SerialType',
      //   type: 'item',
      //   url: 'serial-type',
      //   translate: 'SerialType',
      //   end: true,
      // },


    ],
  },
  {
    id: 14,
    title: 'Request',
    translate: 'Request',
    type: 'item',
    icon: 'feather:git-pull-request',
    // url: 'request',
     url: 'qr',
  },
  {
    id: 7,
    title: 'Profile',
    translate: 'Profile',
    type: 'item',
    icon: 'heroicons-solid:user',
    // url: 'request',
     url: 'profile',
     children: [
      {
        id: 'inventory',
        title: 'MyProfile',
        type: 'item',
        url: 'profile/my-profile',
        translate: 'MyProfile',
        end: true,
      },
      {
        id: 'inventory',
        title: 'MyProfile',
        type: 'item',
        url: 'profile/language',
        translate: 'MyProfile',
        end: true,
      },
    
    ]
  },


];

export default navigationConfig;
